/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Вид для формы адресной доставки
   */
  app.JointPurchaseDeliveryAddressFormView = app.JointPurchaseDeliveryFormView.extend({
    el: '',

    templateName: '#template-delivery-address-form',

    _initChildViews: function () {
      var jpDistrictsIds = this.collection.map(function (i) {
        return i.get('district_id');
      });
      this.updateFieldsList();
      this.districtPopupView = new app.DistrictPopupView({
        el: this.$('.district-container'),
        districts: this.districts,
        jpDistricts: this.jpDistricts,
        jpDistrictsIds: jpDistrictsIds,
        jpModel: this.model,
        filledFields: true,
      });
      this.districtPopupView.showDistrictField();
    },
  });
})(jQuery);

}.call(window));